import { render, staticRenderFns } from "./NotificationsDrawer.vue?vue&type=template&id=526ef5aa&"
import script from "./NotificationsDrawer.vue?vue&type=script&lang=js&"
export * from "./NotificationsDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports